import {
	DocHeading,
	DocList,
	DocPage,
	DocParagraph,
	DocSectionLink,
	DocSubheading,
	DocTerm,
} from "../DocElements";

export function AgentsPage() {
	return (
		<DocPage title="エージェント">
			<DocParagraph>
				プロジェクトに配属したエージェントで、さまざまな作業に取り組めます。作成したエージェントはそれぞれ専用の環境（ファイルシステムや設定）の中で動くので、同じエージェントで新規チャットを始めても、作成したファイルなどはそのまま残ります。
			</DocParagraph>

			<DocHeading>エージェントページ</DocHeading>
			<DocParagraph>
				エージェントページでは、それぞれのエージェントの概要とチャットを一目で確認できます。
			</DocParagraph>
			<DocSubheading>チャット一覧</DocSubheading>
			<DocParagraph>
				そのエージェントとのチャットが並びます。クリックすると、そのチャットを開きます。
			</DocParagraph>

			<DocSubheading id="agent-actions">操作ボタン</DocSubheading>
			<DocParagraph>カード右上のボタンから、エージェントを操作します。</DocParagraph>
			<DocList>
				<li>
					<DocTerm>起動</DocTerm>
					：エージェントの環境を立ち上げます。起動するとチャットを始められます。
				</li>
				<li>
					<DocTerm>停止</DocTerm>
					：エージェントの環境を止めます。
				</li>
				<li>
					<DocTerm>再起動</DocTerm>
					：環境を停止してから、もう一度起動します。
				</li>
				<li>
					<DocTerm>設定</DocTerm>
					（歯車のボタン）：エージェントの設定ダイアログを開きます。
				</li>
			</DocList>

			<DocSubheading>データの保存</DocSubheading>
			<DocParagraph>
				エージェントを停止しても、環境内のデータは残ります。ただし、エージェントを削除すると、環境内のファイルはすべて削除されます。エージェントを削除してもデータを残したい場合は、
				<DocSectionLink id="shared-volumes">共有ボリューム</DocSectionLink>を使ってください。
			</DocParagraph>

			<DocHeading>設定</DocHeading>
			<DocParagraph>
				カードの歯車ボタンから開く設定ダイアログには、次のタブがあります。
			</DocParagraph>

			<DocSubheading>エージェント詳細</DocSubheading>
			<DocParagraph>名前の変更、ディスク使用量などの確認、ディスクの拡張ができます。</DocParagraph>

			<DocSubheading>ネットワーク</DocSubheading>
			<DocParagraph>エージェントが外部と通信できるドメインを設定します。</DocParagraph>

			<DocSubheading>USB 機器</DocSubheading>
			<DocParagraph>
				デバイスに差したUSB機器から、エージェントに渡すものを選びます。デバイスで動くエージェントでだけ表示されます。詳しくは「
				<DocSectionLink page="devices" id="usb">
					USB機器やロボットとつなぐ
				</DocSectionLink>
				」を見てください。
			</DocParagraph>

			<DocSubheading>ロボット</DocSubheading>
			<DocParagraph>
				デバイスにつながったロボットを、エージェントから動かせるようにします。デバイスで動くエージェントでだけ表示されます。「ロボットを使う」は次の起動から反映されます。ほかのエージェントがロボットを使っている間は、ロボットを使う設定のエージェントを起動できません。ロボットが動くときは、停止ボタンをすぐに押せる人がそばにいるようにしてください。純正のVRやAgiBotのアプリでロボットを動かしている間は、エージェントから動かさないでください。
			</DocParagraph>

			<DocSubheading>シークレット</DocSubheading>
			<DocParagraph>
				APIキーなどを環境変数として登録します。エージェントには実際の値は見えません。
			</DocParagraph>

			<DocSubheading id="shared-volumes">共有ボリューム</DocSubheading>
			<DocParagraph>
				組織の共有ボリュームをエージェントにマウントします。共有ボリュームのデータはエージェントを削除しても残り、ほかのエージェントとも共有できます。
			</DocParagraph>

			<DocSubheading>プラグイン一覧</DocSubheading>
			<DocParagraph>エージェントにプラグインをインストール・アンインストールします。</DocParagraph>

			<DocSubheading>マーケットプレイス</DocSubheading>
			<DocParagraph>
				プラグインの入手元（マーケットプレイス）を確認し、最新の内容への更新や削除をします。Izanagiの公式マーケットプレイスは自動で登録されます。
			</DocParagraph>

			<DocSubheading>ターミナル</DocSubheading>
			<DocParagraph>
				エージェントの環境をターミナルから直接操作します。エージェントの起動中のみ使えます。
			</DocParagraph>

			<DocSubheading>そのほか</DocSubheading>
			<DocParagraph>エージェントIDの確認や、エージェントの削除ができます。</DocParagraph>
		</DocPage>
	);
}
